import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-meteo',
  templateUrl: './meteo.component.html',
  styleUrls: ['./meteo.component.scss']
})
export class MeteoComponent implements OnInit {
  
  @ViewChild('theModalGuida') theModalGuida: ElementRef;
  viewAttuale=1

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.route.params.subscribe(params => {

      if (params['sezione'] && params['sezione'] == "archivi") {
        this.viewAttuale=2
      } else {
        this.viewAttuale=1
      }

    });
   }

  ngOnInit(): void {
  }

  openModal(modal){
    let ref = this;
    ref.modalService.open(modal, { backdrop: 'static', windowClass: "modalGuida" });
  }

  closeSingleModal(modal) {
    modal.close('close');
  }

  switchSezione(sezione: number): void {
    this.viewAttuale = sezione;
  }

}
